import { ReportFilters } from '../types/types';

export interface CompleteFilters {
  factories?: string[];
  quarters?: string[];
  years?: string[];
  directions?: string[];
  gops?: string[];
}

export const transformFiltersForCompleteEndpoint = (currentFilters, months, availableFactories, gopDirections, formGops) => {
  const result: CompleteFilters = {};
  if (currentFilters?.factoryGop?.selectedIds && currentFilters.factoryGop.selectedIds.length > 0) {
    result.factories = currentFilters.factoryGop.selectedIds.map(String);
  } else {
    result.factories = availableFactories?.map((f) => String(f.id || f.ID)) || [];
  }
  if (currentFilters?.formGop?.selectedIds && currentFilters.formGop.selectedIds.length > 0) {
    const selectedGopId = currentFilters.formGop.selectedIds[0];
    result.directions = gopDirections?.map((d) => String(d.ID || d.id)) || [];
  } else {
    result.directions = gopDirections?.map((d) => String(d.ID || d.id)) || [];
  }

  if (currentFilters?.formGop?.selectedIds && currentFilters.formGop.selectedIds.length > 0) {
    result.gops = currentFilters.formGop.selectedIds.map(String);
  }

  if (currentFilters?.year?.selectedIds && currentFilters.year.selectedIds.length > 0) {
    result.years = currentFilters.year.selectedIds.map(String);
  } else {
    result.years = ['2025'];
  }

  if (currentFilters?.month?.selectedIds && currentFilters.month.selectedIds.length > 0) {
    const quarterIds = currentFilters.month.selectedIds;
    result.quarters = quarterIds.map((id: any) => {
      const monthItem = months.find((m: any) => m.ID === id);
      if (monthItem && monthItem.Value) {
        return monthItem.Value;
      }
      return `Q${id}`;
    });
  } else {
    result.quarters = ['Q1'];
  }

  const requiredParams = ['factories', 'quarters', 'years', 'directions'];
  const missingParams = requiredParams.filter((param) => !result[param] || result[param].length === 0);

  if (missingParams.length > 0) {
    console.log('Отсутствуют параметры:', missingParams);
  }

  return result;
};
